import {AbstractEvent} from "@/modules/base/events";
import {GateTypeEnum} from "@/modules/action-points/enums";
import {Team} from "@/modules/team/entity";

export default class BeforeCurrencyChangeEvent extends AbstractEvent {
  constructor(
    public type: GateTypeEnum,
    public team: Team,
    public value: number,
  ) {
    super();
  }
}